import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userManager } from "./oidc-client";

export default function Callback() {
  const navigate = useNavigate();

  useEffect(() => {
    userManager.signinRedirectCallback().then(() => {
      navigate("/");
    });
  }, [navigate]);

  return <p>Giriş yapılıyor...</p>;
}
